// extracted by mini-css-extract-plugin
export default {"labelView":"LabelListHover_labelView__el195","labelText":"LabelListHover_labelText__AwHS9"};